import { mockBuilder } from '../../utils/builderHelper.es.js';
import { ProofOfRightsContentTypeEnum, ProofOfRightsTypeEnum } from '../../enums/ProofOfRightsEnums.es.js';
import { ProofOfRights } from './ProofOfRights.es.js';

/** @module Mocks */ /** typedoc */
function aProofOfRights() {
    return mockBuilder(new ProofOfRights())
        .withId('default-proof-of-rights-id')
        .withValue('Default ProofOfRights value')
        .withContentType(ProofOfRightsContentTypeEnum.Samples)
        .withProofType(ProofOfRightsTypeEnum.Url);
}

export { aProofOfRights };
